import React from 'react';
import Cookie from 'js-cookie';
import {localizeUrl} from '@homeaway/localization-utils';

import TransitionBanner from '@homeaway/react-brand-transition-banner';

type Experiment = {
    value: boolean;
};

type Experiments = {[key: string]: Experiment};

type BannerData = {
    vgdcParam?: string;
    locale?: string;
    siteName?: string;
    translations: {[key: string]: string};
};

export type BannerProps = {bannerData: BannerData; experiments: Experiments};

const LINGUA_KEYS = {
    preTitle: 'pre.transition.title.px.login',
    preInfo: 'pre.transition.info.px.login',
    postTitle: 'post.transition.title.px.login',
    postInfo: 'post.transition.info.px.login',
    postLearnMore: 'post.transition.learnmore',
    postLink: 'post.transition.learnmore.link',
};
const POST_LINK_URL = {
    postLink: '/l/hello-vrbo-partner',
};
const BANNER_BRAND_NAMES = {
    VRUS: 'VacationRentals',
    LXUS: 'LuxuryRentals',
};
const TransitionBannerContainer = ({bannerData, experiments}: BannerProps) => {
    const isPreBannerTest =
        experiments.HA_GX_PRE_BRAND_TRANSITION_PX &&
        experiments.HA_GX_PRE_BRAND_TRANSITION_PX.value
            ? true
            : false;
    const isPostBannerTest =
        experiments.HA_GX_POST_BRAND_TRANSITION_PX &&
        experiments.HA_GX_POST_BRAND_TRANSITION_PX.value
            ? true
            : false;

    const vgdcParam = bannerData.vgdcParam || Cookie.get('vgdc');

    if (isPreBannerTest) {
        // get month message for pre-transition banner
        const monthMessage =
            bannerData.translations['pre.transition.month.march'];
        const preData = {
            title: bannerData.translations[LINGUA_KEYS.preTitle],
            info: bannerData.translations[LINGUA_KEYS.preInfo]
                ? bannerData.translations[LINGUA_KEYS.preInfo].replace(
                      '{0}',
                      monthMessage
                  )
                : '',
            siteName: bannerData.siteName,
        };
        return (
            <TransitionBanner
                useCookie
                forPreTransition
                title={preData.title}
                info={preData.info}
                useCookieOnClose
                siteName={preData.siteName}
            />
        );
    } else if (isPostBannerTest) {
        let postData = {
            title: bannerData.translations[LINGUA_KEYS.postTitle],
            info: bannerData.translations[LINGUA_KEYS.postInfo],
            learnMore: bannerData.translations[LINGUA_KEYS.postLearnMore],
            link: bannerData.translations[LINGUA_KEYS.postLink],
            locale: bannerData.locale,
            siteName: bannerData.siteName,
        };

        postData.link =
            postData.link &&
            postData.link.replace(
                '{infoLink}',
                localizeUrl(POST_LINK_URL.postLink, window.__SITE_CONTEXT__)
            );

        if (vgdcParam && BANNER_BRAND_NAMES[vgdcParam]) {
            postData.title =
                postData.title &&
                postData.title.replace(
                    'HomeAway',
                    BANNER_BRAND_NAMES[vgdcParam]
                );
            postData.info =
                postData.info &&
                postData.info.replace(
                    'HomeAway',
                    BANNER_BRAND_NAMES[vgdcParam]
                );
        }
        return (
            <TransitionBanner
                useCookie={false}
                forPreTransition={false}
                title={postData.title}
                info={postData.info}
                vgdc={vgdcParam}
                learnMore={postData.learnMore}
                link={postData.link}
                locale={postData.locale}
                siteName={postData.siteName}
            />
        );
    }
    return null;
};

export default TransitionBannerContainer;
